



































































import { Component, Emit, Model, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class DotCounter extends Vue {

    @Model('change', Number)
    dots!: number;

    @Prop()
    dotsRemaining!: number;

    @Prop({default: 1})
    changeValue!: number;

    @Prop({default: false})
    readonly!: boolean

    @Prop()
    manualValue!: boolean;

    @Prop({default: false})
    disableDecrement!: boolean

    @Prop({default: false, type: Boolean})
    zeroOut!: boolean

    @Prop({default: false, type: Boolean})
    distribute!: boolean

    @Prop({default: false})
    disableButtons!: boolean

    private newValue: number = this.dots;

    mounted() {
        this.newValue = this.dots;
    }

    @Watch("dots")
    private dotsChanged() {
        this.newValue = this.dots;
    }

    @Emit("new-value")
    @Emit("change")
    fieldChange() {
        let diff = this.newValue - this.dots;
        if (this.dotsRemaining - diff < 0) {
            this.newValue = this.dots + this.dotsRemaining;
            diff = this.dotsRemaining;
        } else if (this.newValue < 0) {
            this.newValue = 0;
            diff = 0 - this.dots
        }
        this.$emit('changed', {value: this.newValue, diff: diff})

        return this.newValue;
    }


    @Emit("increment-dot")
    @Emit("new-value")
    @Emit("change")
    incrementDot() {
        this.$emit('changed', {value: this.newValue, diff: this.changeValue})
        return this.dots + this.changeValue;
    }

    @Emit("decrement-dot")
    @Emit("new-value")
    @Emit("change")
    decrementDot() {
        this.$emit('changed', {value: this.newValue, diff: this.changeValue * -1})
        return Math.max(0, this.dots - this.changeValue);
    }

    @Emit("zero-out")
    private zero() {

    }

    @Emit()
    private distributeOut() {

    }

}
